var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"memo",style:({height: _vm.height + 'px'})},[(_vm.label !== false)?_c('div',{staticClass:"memo__label"},[_vm._v(_vm._s(_vm.label)+" "),(!_vm.optional)?_c('span',[_vm._v("*")]):_vm._e()]):_vm._e(),_c('textarea',{style:({
			top: _vm.label === false ? '0' : '22px',
			padding: _vm.padding + 'px',
			height: (_vm.height - 19) + 'px'
		}),attrs:{"type":"text"},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }